{
  "title": "Tasha's Caustic Brew",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (30-foot line)",
  "components": "V, S, M (a bit of rotten food)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A stream of acid emanates from you in a line 30 feet long and 5 feet wide in a direction you choose. Each creature in the line must succeed on a Dexterity saving throw or be covered in acid for the spell’s duration or until a creature uses its action to scrape or wash the acid off itself or another creature. A creature covered in the acid takes 2d4 acid damage at start of each of its turns.",
    "At Higher Levels. When you cast this spell using a spell slot 2nd level or higher, the damage increases by 2d4 for each slot level above 1st."
  ],
  "spellLists": ["artificer", "eldritch-knight", "sorcerer", "wizard"]
}
